
import React from "react";
import Popper from "@mui/material/Popper";
import { useMultiColumnGlobalStyles } from "../components/globalStyles";

// Shared column-track definition so a popper's header row and each option
export const getMultiColumnGridTemplate = (labelKeyArr) =>
  labelKeyArr.map((item) => item.width || "1fr").join(" ");

const createMultiColumnPopper = (labelKeyArr, centerColumns = false) => {
  const CustomPopper = (props) => {
    const globalClasses = useMultiColumnGlobalStyles();
    const gridTemplateColumns = getMultiColumnGridTemplate(labelKeyArr);
    const popperMainClassName = centerColumns
      ? `${globalClasses.multiColPopperMain} ${globalClasses.multiColPopperCentered}`
      : globalClasses.multiColPopperMain;

    return (
      <Popper {...props} placement="bottom-start" style={{ width: props.style?.width }}>
        <div className={popperMainClassName}>
          <div className={globalClasses.multiColPopper} style={{ gridTemplateColumns }}>
            {labelKeyArr.map((item) => (
              <span key={item.key}>
                {item.label || item.key}
              </span>
            ))}
          </div>
          {props.children}
        </div>
      </Popper>
    );
  };

  return CustomPopper;
};

export default createMultiColumnPopper;
